import { AbsoluteFill, useCurrentFrame, useVideoConfig, interpolate, spring } from "remotion";
import React from "react";

// VFX: Minimal Line Lower Third
// Category: lower-thirds · Tags: lower-third, minimal, documentary, clean, reveal
export default function LowerMinimalLineDocumentary1500Ms() {
  const frame = useCurrentFrame();
  const { fps } = useVideoConfig();
  const line = interpolate(frame, [0, 18], [0, 1], { extrapolateRight: "clamp" });
  const text = spring({ frame: frame - 14, fps, config: { damping: 22 } });
  return (
    <AbsoluteFill style={{ background: "transparent", justifyContent: "flex-end", alignItems: "flex-start", padding: 120 }}>
      <div style={{ display: "flex", flexDirection: "column", gap: 12, paddingBottom: 80 }}>
        <div style={{
          width: `${line * 480}px`, height: 2, background: "#f8fafc",
          marginBottom: 16,
        }} />
        <div style={{
          color: "#f8fafc", fontFamily: "Inter, sans-serif", fontSize: 56, fontWeight: 600,
          opacity: text, transform: `translateY(${interpolate(text, [0, 1], [12, 0])}px)`,
          letterSpacing: 1,
        }}>
          Guilherme Ribeiro
        </div>
        <div style={{
          color: "#94a3b8", fontFamily: "Inter, sans-serif", fontSize: 28, fontWeight: 400,
          opacity: text, transform: `translateY(${interpolate(text, [0, 1], [12, 0])}px)`,
          letterSpacing: 3, textTransform: "uppercase",
        }}>
          Fundador · Dimus
        </div>
      </div>
    </AbsoluteFill>
  );
}

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
